/**
 * Guided lesson UI modes from LessonPage / chat embeds.
 * `compact` is legacy — treat like tap-first for footer + interaction rules.
 */

/** @param {unknown} lessonUiMode */
export function isTapFirstLessonUi(lessonUiMode) {
  const m = lessonUiMode == null ? '' : String(lessonUiMode);
  return m === 'tapOnly' || m === 'mobileCard' || m === 'compact';
}

/**
 * Guided lesson shell uses tap-first / mobile card modes — engines should prefer tap-only UX.
 * Alias for {@link isTapFirstLessonUi}.
 * @param {unknown} lessonUiMode
 */
export function isGuidedTapOnlyLessonUi(lessonUiMode) {
  return isTapFirstLessonUi(lessonUiMode);
}

/** @param {unknown} lessonUiMode */
export function isMobileCardLayout(lessonUiMode) {
  return String(lessonUiMode || '') === 'mobileCard';
}
